import msFetch from './fetch-service';
import calculateFetchPath from './calculateFetchPath';

export async function sendFileData(payload) {
  const res = await msFetch(calculateFetchPath(`/gap/modulusbarn/v1/upload`), {
    method: 'POST',
    body: payload,
  });

  if (!res.ok) {
    throw res.statusText;
  }

  return res;
}

export async function fetchRSAKey() {
  const res = await msFetch(calculateFetchPath(`/gap/modulusbarn/v1/key`), {
    method: 'GET',
  });

  if (!res.ok) {
    throw res;
  }

  return res.json();
}
